import ScrollAnchor from './ScrollAnchor';

export default ScrollAnchor;
